import PubSub from "underpub-js";

var CardCallToAction = function(options) {

	this.options = {
		$el: false,
		baseClass: 'el-CardCallToAction',
	};

	$.extend(true, this.options, options);

};

CardCallToAction.prototype.init = function() {

	var self = this;

};

export default CardCallToAction;
